import { Vehicle } from "../Interfaces/vehicle.type";

const getVehicleDataPush = (vehicle: Vehicle) => ({
  product: {
    vehicle: {
      vin: vehicle.vin,
      vrm: vehicle.vrm,
      unitPrice: vehicle.bidAmount,
      saleCode: vehicle.saleCode,
      saleCountry: "gb",
      saleType: "ecs",
      saleBranch: vehicle.location,
      vehicleType: vehicle.vehicleType,
    },
  },
});

export default getVehicleDataPush;
